/* Speakers and Worship Leaders List */

function leadersListFn() {
	const speakersAndWorshipLeadersBlocks = document.querySelectorAll('.block.speakersAndWorshipLeaders');

	function btnToggler(el) {
		if (el.classList.contains('asc')) {
			if (!el.classList.contains('uponly')) {
				el.classList.remove('asc');
				el.classList.add('desc');
			}
		} else if (el.classList.contains('desc')) {
			if (el.classList.contains('binary')) {
				el.classList.add('asc');
			}
			el.classList.remove('desc');
		} else {
			el.classList.add('asc');
		}
	}
	function btnReset(el) {
		el.classList.remove('asc');
		el.classList.remove('desc');
	}

	speakersAndWorshipLeadersBlocks.forEach(function(speakersAndWorshipLeadersBlock) {
		const speakersAndWorshipLeadersHeader = speakersAndWorshipLeadersBlock.querySelector('.speakerdates_list_header');
		const speakersAndWorshipLeadersList = speakersAndWorshipLeadersBlock.querySelector('.speakerdates_list .speakerdates_list_items');
		const speakersAndWorshipLeadersItems = speakersAndWorshipLeadersList.querySelectorAll('.speakerdate');
		const speakersAndWorshipLeaders = speakersAndWorshipLeadersBlock.querySelectorAll('.speakerdate_person');

		const startDateBtn = speakersAndWorshipLeadersHeader.querySelector('.startDate button');
		const speakerBtn = speakersAndWorshipLeadersHeader.querySelector('.speaker button');
		const worshipLeaderBtn = speakersAndWorshipLeadersHeader.querySelector('.worshipLeader button');

		let list = [];
		for (var i=0; i < speakersAndWorshipLeadersItems.length; i++) {
			list.push(speakersAndWorshipLeadersItems[i]);
		}

		function sortByDate() {
			list.sort(function(a, b){
				var aa = parseInt(a.getAttribute('data-date'));
				var bb = parseInt(a.getAttribute('data-date'));
				return aa < bb ? -1 : (aa > bb ? 1 : 0);
			});
			// list.reverse();
			for (var i=0; i < list.length; i++){
				speakersAndWorshipLeadersList.insertBefore(list[i], speakersAndWorshipLeadersList.firstChild);
			}
		}

		function sortBySpeaker() {
			list.sort(function(a, b){
				var aa = parseInt(a.getAttribute('data-speaker'));
				var bb = parseInt(a.getAttribute('data-speaker'));
				return aa > bb ? -1 : (aa < bb ? 1 : 0);
			});
			// list.reverse();
			for (var i=0; i < list.length; i++){
				speakersAndWorshipLeadersList.insertBefore(list[i], speakersAndWorshipLeadersList.firstChild);
			}
		}

		function sortByWorshipLeader() {
			list.sort(function(a, b){
				var aa = parseInt(a.getAttribute('data-worshipleader'));
				var bb = parseInt(a.getAttribute('data-worshipleader'));
				return aa > bb ? -1 : (aa < bb ? 1 : 0);
			});
			// list.reverse();
			for (var i=0; i < list.length; i++){
				speakersAndWorshipLeadersList.insertBefore(list[i], speakersAndWorshipLeadersList.firstChild);
			}
		}

		if (startDateBtn !== null) {
			startDateBtn.classList.add('js-active');
			startDateBtn.addEventListener('click', function() {
				btnToggler(startDateBtn);
				btnReset(speakerBtn);
				btnReset(worshipLeaderBtn);

				const startDateAttr = speakersAndWorshipLeadersList.getAttribute('data-startdate');
				if (startDateAttr == '') {
					sortByDate();
					speakersAndWorshipLeadersList.setAttribute('data-startdate', 'asc');
				}

				speakersAndWorshipLeadersList.setAttribute('data-speaker', '');
				speakersAndWorshipLeadersList.setAttribute('data-worshipleader', '');
			});
		}

		if (speakerBtn !== null) {
			speakerBtn.classList.add('js-active');
			speakerBtn.addEventListener('click', function() {
				btnToggler(speakerBtn);
				btnReset(startDateBtn);
				btnReset(worshipLeaderBtn);

				const speakerAttr = speakersAndWorshipLeadersList.getAttribute('data-speaker');
				if (speakerAttr == '') {
					sortBySpeaker();
					speakersAndWorshipLeadersList.setAttribute('data-speaker', 'asc');
				}

				speakersAndWorshipLeadersList.setAttribute('data-startdate', '');
				speakersAndWorshipLeadersList.setAttribute('data-worshipleader', '');
			});
		}

		if (worshipLeaderBtn !== null) {
			worshipLeaderBtn.classList.add('js-active');
			worshipLeaderBtn.addEventListener('click', function() {
				btnToggler(worshipLeaderBtn);
				btnReset(startDateBtn);
				btnReset(speakerBtn);

				const worshipLeaderAttr = speakersAndWorshipLeadersList.getAttribute('data-worshipleader');
				if (worshipLeaderAttr == '') {
					sortByWorshipLeader();
					speakersAndWorshipLeadersList.setAttribute('data-worshipleader', 'asc');
				}

				speakersAndWorshipLeadersList.setAttribute('data-startdate', '');
				speakersAndWorshipLeadersList.setAttribute('data-speaker', '');
			});
		}

		const desktopQuery = window.matchMedia('(min-width: 1200px)')
		function handleDesktopQueryChange(e) { if (e.matches) {
			speakersAndWorshipLeaders.forEach(function(person) {
				person.classList.add('js-active');
				const bio = person.querySelector('.feature-week-guest-bio');
				if (bio !== null) {
					person.addEventListener('mouseover', function() {
						bio.classList.add('active');
					});
					person.addEventListener('mouseout', function() {
						bio.classList.remove('active');
					});
				}
			});
		} else {
			speakersAndWorshipLeaders.forEach(function(person) {
				person.classList.add('js-active');

				const bio = person.querySelector('.feature-week-guest-bio');
				if (bio !== null) {
					person.addEventListener('mouseenter', function() {
						bio.classList.add('active');
					});

					const closeButton = bio.querySelector('.close');
					closeButton.focus();
					closeButton.addEventListener('mouseenter', function() {
						bio.classList.remove('active');
					});
					closeButton.addEventListener('click', function() {
						bio.classList.remove('active');
					});
				}
			});
		}}
		desktopQuery.addEventListener('change', handleDesktopQueryChange);
		handleDesktopQueryChange(desktopQuery);
	});
}

const leadersList = {
	init: function() {
		leadersListFn();
	},
};

export default leadersList;
